
export default {
	name: 'TitleBox',
	props: {
		renderBack: {
			type: Boolean,
			default: true
		},
		customGoBack: {
			type: Function,
			default: null
		},
		smallPadding: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		goBack() {
			if (this.customGoBack) {
				this.customGoBack()
				return
			}
			this.$router.back()
		}
	}
}
